import Bugsnag from '@bugsnag/js'
import { createSlice, PayloadAction, createAction } from '@reduxjs/toolkit'
import jwtDecode from 'jwt-decode'

import { config } from '@fairhq/common'

import { AuthUser, CharlieUser } from 'auth/types'
import { handleErrorState } from 'store/helpers/handleErrorState'
import { isClearAll } from 'store/helpers/isClearAll'
import { isRejected } from 'store/helpers/isRejected'

import { QueryStatus } from 'store/types'

import { AuthState } from './types'

export const clear = createAction('auth/clear')

const initialState: Partial<AuthState> = { userQueryStatus: QueryStatus.IDLE }

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (
      state,
      action: PayloadAction<{ user: AuthUser; charlieUser: CharlieUser }>
    ) => {
      state.userQueryStatus = QueryStatus.LOADING
      if (!action?.payload) {
        return
      }
      state.user = action.payload.user || {}
      state.charlieUser = action.payload.charlieUser || {}
      const { userId } = action.payload.charlieUser
      state.intercom = {
        intercomUserHash: action.payload.charlieUser.intercomUserHash,
        intercomId: action.payload.charlieUser?.teamMemberId!,
      }

      window?.gtag?.('config', config.analytics, { userId })

      Bugsnag.setUser(userId)

      state.userQueryStatus = QueryStatus.SUCCESS
    },
    setJWT(state, action) {
      const decodedToken: { permissions: string[] } = jwtDecode(action.payload)
      state.hasPermissions = decodedToken?.permissions?.length > 0
      state.jwt = action.payload
      localStorage.setItem(config.tokenKey, action.payload || '')
    },
  },
  extraReducers: builder => {
    builder
      .addCase(clear, () => initialState)
      .addMatcher(isClearAll(), () => initialState)
      .addMatcher(isRejected('auth'), handleErrorState)
  },
})

export const { actions: authActions, reducer: authReducer } = authSlice
